import React, { useMemo } from "react";
import styles from "./styles.module.css";
import { CustomText } from "components/ui";
import { theme } from "constants/theme";
import parse from "html-react-parser";
import DOMPurify from "dompurify";

interface BlogViewerProps {
  blocks: any[];
  isDesktop?: boolean;
}

export const BlogViewer = ({ blocks, isDesktop = true }: BlogViewerProps) => {
  const renderedBlocks = useMemo(() => {
    if (!Array.isArray(blocks)) return null;

    return blocks.map((block) => {
      const { id, type, data } = block;

      switch (type) {
        case "paragraph":
          return (
            <CustomText
              key={id}
              text={parse(DOMPurify.sanitize(data.text))} // sanitize + parse HTML
              size={isDesktop ? 20 : 15}
              color="#444"
              styles={{
                lineHeight: isDesktop ? "28px" : "20px",
                marginBottom: "16px",
              }}
            />
          );

        // case "header":
        //   const level = data.level >= 1 && data.level <= 6 ? data.level : 2;
        //   const Tag = `h${level}` as keyof JSX.IntrinsicElements;
        //   return React.createElement(
        //     Tag,
        //     { key: id, className: styles.customHeader },
        //     data.text
        //   );

        // case "list":
        //   const ListTag = data.style === "ordered" ? "ol" : "ul";
        //   return (
        //     <ListTag key={id} className={styles.customList}>
        //       {data.items.map((item: any, i: number) => (
        //         <li key={i} className={styles.customListItem}>
        //           <CustomText
        //             key={id}
        //             text={item.content || item}
        //             size={isDesktop ? 20 : 15}
        //             color={"#444"}
        //             styles={{
        //               lineHeight: isDesktop ? "28px" : "20px",
        //             }}
        //           />
        //         </li>
        //       ))}
        //     </ListTag>
        //   );

        case "quote":
          return (
            <blockquote
              key={id}
              className={styles.customQuote}
              style={{ textAlign: data.alignment || "center" }}
            >
              <em>“{data.text}”</em>
            </blockquote>
          );

        case "image":
          return (
            <div key={id} className={styles.customImageWrapper}>
              <img
                src={data.file?.url || ""}
                alt="icon"
                className={styles.blogImage}
              />
              <CustomText
                size={isDesktop ? 18 : 15}
                text={data.caption}
                color={theme.colors.neutral[30]}
                styles={{
                  textAlign: "center",
                  fontStyle: "italic",
                  margin: "0 auto 40px",
                }}
              />
            </div>
          );

        // case "code":
        //   return (
        //     <pre key={id} className={styles.customCode}>
        //       <code>{data.code}</code>
        //     </pre>
        //   );

        default:
          return null;
      }
    });
  }, [blocks, isDesktop]);

  return <div className={styles.blogWrapper}>{renderedBlocks}</div>;
};
